<template>
  <div class="plan-selection-page">
    <!-- 我的保单悬浮窗 -->
    <my-policy-float />

    <!-- 添加被保险人弹窗 -->
    <add-insured-person
      v-model="showAddDialog"
      @confirm="handleAddInsured"
    />

    <!-- 批量投保弹窗 -->
    <batch-insured-import
      v-model="showBatchDialog"
      @confirm="handleBatchImport"
    />



    <!-- 协议查看弹窗 -->
    <agreement-viewer
      v-model="showAgreementViewer"
      :agreement="currentAgreement"
      :is-in-sequence="isSequenceMode"
      :current-index="currentAgreementIndex"
      :total-count="agreementSequence.length"
      @close="handleAgreementClose"
      @next="handleAgreementNext"
      @complete="handleAgreementComplete"
      @viewed="handleAgreementViewed"
    />
    <!-- 返回上一级 -->
    <div class="page-toolbar">
      <button class="back-btn" type="button" @click="goBack">
        <span class="back-icon">←</span>
        <span>返回</span>
      </button>
    </div>

    <!-- 步骤条 -->
    <div class="step-header">
      <div class="step-item active">
        <div class="step-number">1</div>
        <div class="step-text">计划选择</div>
      </div>
      <div class="step-line"></div>
      <div class="step-item">
        <div class="step-number">2</div>
        <div class="step-text">确认支付</div>
      </div>
      <div class="step-line"></div>
      <div class="step-item">
        <div class="step-number">3</div>
        <div class="step-text">投保成功</div>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="main-container">
      <!-- 左侧内容 -->
      <div class="left-content">
        <div class="section-title">
          <span class="title-icon"></span>
          计划选择
        </div>
        
        <!-- 计划选择卡片区域 - 步骤2实现 -->
        <div class="plan-cards-area">
          <div
            v-for="plan in plans"
            :key="plan.id"
            class="plan-card"
            :class="{ active: selectedPlan === plan.id }"
            @click="selectPlan(plan.id)"
          >
            <div class="plan-name">{{ plan.planShortName }}</div>
            <div class="plan-type">{{ plan.planLevelText }}</div>
          </div>
        </div>

        <!-- 保障项目表格 - 步骤3实现 -->
        <div class="coverage-table-area">
          <div class="coverage-table">
            <div class="table-header">
              <span class="header-left">保障项目</span>
              <span class="header-right">保障金额（元）</span>
            </div>
            <div class="table-body">
              <div
                v-for="(item, index) in currentCoverage"
                :key="index"
                class="table-row"
              >
                <span class="row-name">{{ item.coverageName }}</span>
                <span class="row-amount">{{ item.sumInsuredStr }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 特别约定 - 步骤3实现 -->
        <div class="special-notes-area">
          <div class="notes-title">特别约定</div>
          <div class="notes-content">
            <p>1. 本保险合同平安产险附加意外伤害住院津贴保险（互联网版）- <span class="notes-content-weight">意外住院津贴的每日津贴为50元，累计给付以30天为限，当累计给付天数达到30天时，本项保险责任终止。</span></p>
            <p>2. 本保险保障范围为在 <span class="notes-content-weight">中华人民共和国境内（不含港澳台地区）</span> 发生的保险事故；</p>
            <p>3. 本保险合同的 <span class="notes-content-weight">被保险人年龄须为0周岁30天-90周岁</span> ，超出该年龄范围投保无效。</p>
            <p>4. 本保险合同的伤残鉴定标准为 <span class="notes-content-weight">《人身保险伤残评定及代码》（标准编号为GB/T 44893-2024），残疾赔偿金计算方式为“意外伤害身故和残疾保额”*“伤残赔付比例”，“伤残赔付比例”为十级10%、九级20%、八级30%、七级40%、六级50%、五级60%、四级70%、三级80%、二级90%、一级100%。</span> </p>
            <p>5. 根据原保监发【2015】90号文件： <span class="notes-content-weight">除航空意外死亡及重大自然灾害意外死亡外，任何不满10周岁的被保险人，其死亡保险金额不得超过人民币20万元；已满10周岁但未满18周岁的被保险人，其死亡保险金额不得超过人民币50万元。保险人对于超出监管部门规定限额的保险金额不承担保险责任。</span> </p>
          </div>
        </div>

        <!-- 保障期限 - 步骤4实现 -->
        <div class="duration-section">
          <div class="section-title">
            <span class="title-icon"></span>
            保障期限
          </div>
          
          <!-- 天数快捷选择 -->
          <div class="day-options">
            <div
              v-for="option in dayOptions"
              :key="option.value"
              class="day-option"
              :class="{ active: selectedDays === option.value }"
              @click="selectDays(option.value)"
            >
              {{ option.label }}
            </div>
          </div>
          
          <!-- 日期选择 -->
          <div class="date-picker-row">
            <div class="date-field">
              <span class="date-label">起保日期 <span class="required">*</span></span>
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDate"
                    placeholder="请输入"
                    readonly
                    outlined
                    dense
                    solo
                    hide-details
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  @input="startDateMenu = false; calculateEndDate()"
                  :min="tomorrowDate"
                  no-title
                  locale="zh-cn"
                ></v-date-picker>
              </v-menu>
            </div>
            
            <div class="date-field">
              <span class="date-label">结束日期</span>
              <v-text-field
                v-model="endDate"
                placeholder="自动计算"
                readonly
                outlined
                dense
                solo
                hide-details
                disabled
                class="disabled-field"
              ></v-text-field>
            </div>
            
            <div class="days-calculation">
              <span class="calc-label">保障时长计算为：</span>
              <span class="calc-value">{{ calculatedDays }}天</span>
            </div>
          </div>
        </div>

        <!-- 投保人信息 - 步骤5实现 -->
        <div class="policyholder-section">
          <div class="section-title">
            <span class="title-icon"></span>
            投保人（企业信息）
          </div>
          
          <div class="form-row">
            <div class="form-field">
              <label class="field-label">企业名称 <span class="required">*</span></label>
              <v-text-field
                v-model="policyholder.name"
                placeholder="请输入企业名称"
                outlined
                dense
                solo
                hide-details
                class="custom-field"
              ></v-text-field>
            </div>
            
            <div class="form-field">
              <label class="field-label">统一信用代码 <span class="required">*</span></label>
              <v-text-field
                v-model="policyholder.certNo"
                placeholder="请输入信用代码"
                outlined
                dense
                solo
                :error-messages="certNoError"
                class="custom-field"
                @blur="validateCertNo"
                @input="certNoError = ''"
              ></v-text-field>
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-field">
              <label class="field-label">联系方式 <span class="required">*</span></label>
              <v-text-field
                v-model="policyholder.phone"
                placeholder="请输入联系方式"
                outlined
                dense
                solo
                hide-details
                class="custom-field"
              ></v-text-field>
            </div>
            
            <div class="form-field">
              <label class="field-label">电子邮箱 <span class="required">*</span></label>
              <v-text-field
                v-model="policyholder.email"
                placeholder="请输入邮箱"
                outlined
                dense
                solo
                :error-messages="emailError"
                class="custom-field"
                @blur="validateEmail"
                @input="emailError = ''"
              ></v-text-field>
            </div>
          </div>
        </div>

        <!-- 被保险人信息 - 步骤6实现 -->
        <div class="insured-section">
          <!-- 标题栏 -->
          <div class="section-title">
            <span class="title-icon"></span>
            被保险人
          </div>
          
          <!-- 操作按钮栏 -->
          <div class="insured-actions">
            <v-btn
              outlined
              color="#dd122a"
              class="action-btn"
              @click="showAddDialog = true"
            >
              <v-icon left size="18">add</v-icon>
              添加被保险人
            </v-btn>
            <v-btn
              outlined
              color="#dd122a"
              class="action-btn"
              @click="showBatchDialog = true"
            >
              <v-icon left size="18">file_upload</v-icon>
              批量投保
            </v-btn>
          </div>
          
          <!-- 被保险人表格 -->
          <div class="insured-table-wrapper">
            <!-- 空状态 -->
            <div v-if="insuredList.length === 0" class="empty-state">
              <v-icon size="48" color="#ccc">person_outline</v-icon>
              <p class="empty-text">暂无被保险人</p>
            </div>
            <!-- 表格 -->
            <table v-else class="insured-table">
              <thead>
                <tr>
                  <th style="width: 60px;">序号</th>
                  <th>姓名</th>
                  <th>证件类型</th>
                  <th>联系方式</th>
                  <th>证件号码</th>
                  <th v-if="hasNonIdCard">出生日期</th>
                  <th v-if="hasNonIdCard">性别</th>
                  <th>同投保人关系</th>
                  <th style="width: 80px;">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(insured, index) in paginatedInsuredList" :key="index">
                  <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                  <td>{{ insured.name }}</td>
                  <td>{{ getCertTypeText(insured.certType) }}</td>
                  <td>{{ insured.phone }}</td>
                  <td>{{ insured.certNo }}</td>
                  <td v-if="hasNonIdCard">{{ insured.birthday || '-' }}</td>
                  <td v-if="hasNonIdCard">{{ getGenderText(insured.gender) }}</td>
                  <td>{{ getRelationTypeText(insured.relationType) }}</td>
                  <td>
                    <span
                      class="delete-text"
                      @click="removeInsured(index)"
                    >删除</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <!-- 分页 -->
          <div class="pagination-wrapper" v-if="insuredList.length > 0">
            <v-pagination
              v-model="currentPage"
              :length="totalPages"
              :total-visible="7"
              color="#dd122a"
              circle
            ></v-pagination>
          </div>
          
          <!-- 受益人提示 -->
          <div class="beneficiary-notice">
            <v-icon color="#dd122a" size="16">error</v-icon>
            <span>受益人为法定受益人</span>
          </div>
        </div>
      </div>

      <!-- 右侧价格栏 - 步骤7实现 -->
      <div class="right-sidebar">
        <div class="price-card sticky-card">
          <!-- 保费金额 -->
          <div class="price-header">
            <div class="price-title">当前预计保费</div>
            <div class="price-amount">
              <span class="currency">¥</span>
              <span class="amount">{{ calculatedPrice }}</span>
            </div>
          </div>
          
          <!-- 方案信息 -->
          <div class="plan-info">
            <div class="info-row">
              <span class="info-label">已购方案</span>
              <span class="info-value">{{ currentPlanName }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">保障天数</span>
              <span class="info-value">{{ calculatedDays }}天</span>
            </div>
            <div class="info-row">
              <span class="info-label">投保人数</span>
              <span class="info-value">{{ insuredList.length }}人</span>
            </div>
          </div>
          
          <!-- 协议勾选 -->
          <div class="agreement-section">
            <div class="agreement-item">
              <v-checkbox
                :input-value="agreements.main"
                @change="handleAgreementCheck('main', $event)"
                color="#dd122a"
                hide-details
                dense
                class="agreement-checkbox"
              >
                <template v-slot:label>
                  <span class="agreement-text">
                    本人充分阅读、理解并同意
                    <a 
                      v-for="item in mainAgreements" 
                      :key="item.id"
                      href="javascript:void(0)" 
                      class="agreement-link"
                      @click.stop="openAgreement(item)"
                    >《{{ item.title }}》</a>
                  </span>
                </template>
              </v-checkbox>
            </div>
            
            <div class="agreement-item">
              <v-checkbox
                :input-value="agreements.personalInfo"
                @change="handleAgreementCheck('personalInfo', $event)"
                color="#dd122a"
                hide-details
                dense
                class="agreement-checkbox"
              >
                <template v-slot:label>
                  <span class="agreement-text">
                    同意<a 
                      href="javascript:void(0)" 
                      class="agreement-link"
                      @click.stop="openAgreement(personalInfoAgreement)"
                    >《{{ personalInfoAgreement.title }}》</a>
                  </span>
                </template>
              </v-checkbox>
            </div>
            
            <div class="agreement-item">
              <v-checkbox
                :input-value="agreements.customerAuth"
                @change="handleAgreementCheck('customerAuth', $event)"
                color="#dd122a"
                hide-details
                dense
                class="agreement-checkbox"
              >
                <template v-slot:label>
                  <span class="agreement-text">
                    同意<a 
                      href="javascript:void(0)" 
                      class="agreement-link"
                      @click.stop="openAgreement(customerAuthAgreement)"
                    >《{{ customerAuthAgreement.title }}》</a>
                  </span>
                </template>
              </v-checkbox>
            </div>
          </div>
          
          <!-- 投保人声明 -->
          <div class="declaration-section">
            <div class="declaration-title">投保人声明：</div>
            <div class="declaration-content">
              <p>1、本投保人兹声明各项投保内容填写属实。本人知悉投保人应如实填写各项投保信息，并就保险公司提出的询问据实告知。如未履行如实告知义务的，保险公司有权依法解除保险合同，并对合同解除前发生的保险事故不承担保险责任。</p>
              <p>2、本投保人确认已阅读本产品所有条款，且贵公司已向本人详细介绍了条款的内容，特别就保险条款中免除保险人责任的条款内容和特别约定内容做出明确说明，本人对免除保险人责任的条款的概念、内容及其法律后果，均因贵公司的明确说明已完全理解，并同意投保。</p>
            </div>
          </div>
          
          <!-- 立即投保按钮-->
          <v-btn
            color="#dd122a"
            block
            large
            class="submit-btn"
            :disabled="submitting || !canSubmit"
            :loading="submitting"
            @click="submitOrder"
          >
            立即投保
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddInsuredPerson from './addInsuredPerson.vue';
import BatchInsuredImport from './batchInsuredImport.vue';
import AgreementViewer from './agreementViewer.vue';
import MyPolicyFloat from './MyPolicyFloat.vue';
// import { isRecordingActive, stopRecording, startRecording, hasSavedEvents, clearSavedEvents, clearScreenshotUrls, getRecordingEvents, captureAsBlob, saveScreenshotUrls, loadScreenshotUrls } from '@/utils/recordingUtils';
// import { getPlanList, getCoverageList, submitOrder, uploadScreenshot, getMonitorCode, saveMonitorDetail, saveScreenshotLinks } from '@/api';
import { getPlanList, getCoverageList, submitOrder, getEnterpriseInfo } from '@/api';

export default {
  name: 'PlanSelection',
  components: {
    AddInsuredPerson,
    BatchInsuredImport,
    AgreementViewer,
    MyPolicyFloat
  },
  data() {
    return {
      currentStep: 1,
      selectedPlan: 1,
      plans: [],
      productId: '',
      coverageData: [],
      submitting: false, // 防止重复提交
      // 保障期限数据
      dayOptions: [
        { label: '1天', value: 1 },
        { label: '2天', value: 2 },
        { label: '3天', value: 3 },
        { label: '4-5天', value: 5 },
        { label: '6-7天', value: 7 },
        { label: '8-10天', value: 10 },
        { label: '11-15天', value: 15 },
        { label: '16-20天', value: 20 }
      ],
      selectedDays: 1,
      startDate: '',
      endDate: '',
      startDateMenu: false,
      endDateMenu: false,
      calculatedDays: 0,
      certNoError: '', // 统一信用代码错误提示
      emailError: '', // 邮箱错误提示
      // 投保人信息
      policyholder: {
        name: '',
        certNo: '',
        phone: '',
        email: '',
        holderType: 2,
      },
      // 被保险人信息
      insuredList: [],
      idTypeOptions: ['身份证', '护照', '港澳通行证', '台湾通行证', '出生证', '其他'],
      relationOptions: ['本人', '配偶', '子女', '父母', '其他'],
      showBatchDialog: false,
      showAddDialog: false,
      // 分页
      currentPage: 1,
      pageSize: 5,
      // 协议勾选
      agreements: {
        main: false,
        personalInfo: false,
        customerAuth: false
      },
      // 单价（元/人/天）[天数区间索引]
      pricePerPersonPerDay: {
        // [1天, 2天, 3天, 4-5天, 6-7天, 8-10天, 11-15天, 16-20天]
        1: [0.7, 0.8, 1.3, 1.8, 2.8, 3.5, 5.9, 10.1],
        2: [1.0, 1.4, 1.8, 3.4, 5.3, 7.1, 11.2, 19.6],
        3: [1.5, 2.1, 2.2, 4.8, 7.7, 9.5, 16.8, 30.8]
      },
      // 天数区间配置
      dayRanges: [
        { max: 1, index: 0 },
        { max: 2, index: 1 },
        { max: 3, index: 2 },
        { max: 5, index: 3 },
        { max: 7, index: 4 },
        { max: 10, index: 5 },
        { max: 15, index: 6 },
        { max: 20, index: 7 }
      ],
      // 协议列表
      agreementList: [
        {
          id: 'entrust',
          title: '保险经纪授权委托书&告知书',
          requireTime: true,
          duration: 5,
          images: [
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/1.%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E6%9C%8D%E5%8A%A1%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6/001_4733372.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/1.%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E6%9C%8D%E5%8A%A1%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6/002_4733372.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/1.%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E6%9C%8D%E5%8A%A1%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6/003_4733372.png'
          ]
        },
        {
          id: 'notice',
          title: '投保须知&特别约定',
          requireTime: true,
          duration: 5,
          images: [
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/2.%E6%8A%95%E4%BF%9D%E9%A1%BB%E7%9F%A5&%E7%89%B9%E5%88%AB%E7%BA%A6%E5%AE%9A/2.%E6%8A%95%E4%BF%9D%E9%A1%BB%E7%9F%A5&%E7%89%B9%E5%88%AB%E7%BA%A6%E5%AE%9A.png'
          ]
        },
        {
          id: 'authorization',
          title: '投保人授权协议',
          requireTime: true,
          duration: 5,
          images: [
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/3.%E6%8A%95%E4%BF%9D%E4%BA%BA%E6%8E%88%E6%9D%83%E5%8D%8F%E8%AE%AE/001_4733396.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/3.%E6%8A%95%E4%BF%9D%E4%BA%BA%E6%8E%88%E6%9D%83%E5%8D%8F%E8%AE%AE/002_4733396.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/3.%E6%8A%95%E4%BF%9D%E4%BA%BA%E6%8E%88%E6%9D%83%E5%8D%8F%E8%AE%AE/003_4733396.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/3.%E6%8A%95%E4%BF%9D%E4%BA%BA%E6%8E%88%E6%9D%83%E5%8D%8F%E8%AE%AE/004_4733396.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/3.%E6%8A%95%E4%BF%9D%E4%BA%BA%E6%8E%88%E6%9D%83%E5%8D%8F%E8%AE%AE/005_4733396.png'
          ]
        },
        {
          id: 'privacy',
          title: '易才宏业保险经纪隐私政策',
          requireTime: true,
          duration: 5,
          images: [
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/001_4733399.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/002_4733399.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/003_4733399.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/004_4733399.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/005_4733399.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/006_4733399.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/007_4733399.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/008_4733399.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/009_4733399.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/010_4733399.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/011_4733399.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/012_4733399.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/4.%E6%98%93%E6%89%8D%E5%AE%8F%E4%B8%9A%E4%BF%9D%E9%99%A9%E7%BB%8F%E7%BA%AA%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96/013_4733399.png'
          ]
        },
        {
          id: 'terms',
          title: '保险条款',
          url: '',
          requireTime: true,
          duration: 5,
          isList: true,
          children: [
            {
              id: 'terms-1',
              title: '平安产险旅行意外伤害保险（互联网版）（2025版）条款',
              images: [
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/001_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/002_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/003_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/004_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/005_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/006_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/007_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/008_4732964.png'
              ],
              requireTime: true,
              duration: 10
            },
            {
              id: 'terms-2',
              title: '平安产险附加定残标准、伤残赔付等级和给付比例约定保险条款',
              images: [
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E5%AE%9A%E6%AE%8B%E6%A0%87%E5%87%86%E3%80%81%E4%BC%A4%E6%AE%8B%E8%B5%94%E4%BB%98%E7%AD%89%E7%BA%A7%E5%92%8C%E7%BB%99%E4%BB%98%E6%AF%94%E4%BE%8B%E7%BA%A6%E5%AE%9A%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E5%AE%9A%E6%AE%8B%E6%A0%87%E5%87%86%E3%80%81%E4%BC%A4%E6%AE%8B%E8%B5%94%E4%BB%98%E7%AD%89%E7%BA%A7%E5%92%8C%E7%BB%99%E4%BB%98%E6%AF%94%E4%BE%8B%E7%BA%A6%E5%AE%9A%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.png'
              ],
              requireTime: false,
              duration: 0
            },
            {
              id: 'terms-3',
              title: '平安产险附加意外伤害住院津贴保险（互联网版）条款',
              images: [
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BD%8F%E9%99%A2%E6%B4%A5%E8%B4%B4%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/001_4732958.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BD%8F%E9%99%A2%E6%B4%A5%E8%B4%B4%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/002_4732958.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BD%8F%E9%99%A2%E6%B4%A5%E8%B4%B4%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/003_4732958.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BD%8F%E9%99%A2%E6%B4%A5%E8%B4%B4%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/004_4732958.png'
              ],
              requireTime: false,
              duration: 0
            },
            {
              id: 'terms-4',
              title: '平安产险附加猝死保障保险（互联网版）条款',
              images: [
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E7%8C%9D%E6%AD%BB%E4%BF%9D%E9%9A%9C%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E7%8C%9D%E6%AD%BB%E4%BF%9D%E9%9A%9C%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE%20.png'
              ],
              requireTime: false,
              duration: 0
            },
            {
              id: 'terms-5',
              title: '平安产险附加急性病医疗保险（互联网版）条款',
              images: [
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%80%A5%E6%80%A7%E7%97%85%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/001_4732938.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%80%A5%E6%80%A7%E7%97%85%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/002_4732938.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%80%A5%E6%80%A7%E7%97%85%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/003_4732938.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%80%A5%E6%80%A7%E7%97%85%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/004_4732938.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%80%A5%E6%80%A7%E7%97%85%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/005_4732938.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%80%A5%E6%80%A7%E7%97%85%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/006_4732938.png'
              ],
              requireTime: false,
              duration: 0
            },
            {
              id: 'terms-6',
              title: '平安产险意外险附加突发疾病身故保险（互联网版）（2025版）',
              images: [
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%84%8F%E5%A4%96%E9%99%A9%E9%99%84%E5%8A%A0%E7%AA%81%E5%8F%91%E7%96%BE%E7%97%85%E8%BA%AB%E6%95%85%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/001_4732972.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%84%8F%E5%A4%96%E9%99%A9%E9%99%84%E5%8A%A0%E7%AA%81%E5%8F%91%E7%96%BE%E7%97%85%E8%BA%AB%E6%95%85%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/002_4732972.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%84%8F%E5%A4%96%E9%99%A9%E9%99%84%E5%8A%A0%E7%AA%81%E5%8F%91%E7%96%BE%E7%97%85%E8%BA%AB%E6%95%85%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/003_4732972.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%84%8F%E5%A4%96%E9%99%A9%E9%99%84%E5%8A%A0%E7%AA%81%E5%8F%91%E7%96%BE%E7%97%85%E8%BA%AB%E6%95%85%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/004_4732972.png'
              ],
              requireTime: false,
              duration: 0
            }
          ]
        },
        {
          id: 'disclaimer',
          title: '免责条款',
          images: [
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/6.%E5%85%8D%E8%B4%A3%E6%9D%A1%E6%AC%BE/001_4733402.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/6.%E5%85%8D%E8%B4%A3%E6%9D%A1%E6%AC%BE/002_4733402.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/6.%E5%85%8D%E8%B4%A3%E6%9D%A1%E6%AC%BE/003_4733402.png'
          ],
          requireTime: true,
          duration: 5
        },
        {
          id: 'disclosure',
          title: '信息披露',
          images: [
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/7.%E4%BF%A1%E6%81%AF%E6%8A%AB%E9%9C%B2/001_4733406.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/7.%E4%BF%A1%E6%81%AF%E6%8A%AB%E9%9C%B2/002_4733406.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/7.%E4%BF%A1%E6%81%AF%E6%8A%AB%E9%9C%B2/003_4733406.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/7.%E4%BF%A1%E6%81%AF%E6%8A%AB%E9%9C%B2/004_4733406.png'
          ],
          requireTime: false,
          duration: 0
        },
        {
          id: 'personalInfo',
          title: '个人信息共享协议',
          images: [
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/8.%E4%B8%AA%E4%BA%BA%E4%BF%A1%E6%81%AF%E5%85%B1%E4%BA%AB%E5%8D%8F%E8%AE%AE/001_4733408.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/8.%E4%B8%AA%E4%BA%BA%E4%BF%A1%E6%81%AF%E5%85%B1%E4%BA%AB%E5%8D%8F%E8%AE%AE/002_4733408.png'
          ],
          requireTime: false,
          duration: 0
        },
        {
          id: 'customerAuth',
          title: '客户信息授权',
          images: [
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/9.%E5%AE%A2%E6%88%B7%E4%BF%A1%E6%81%AF%E6%8E%88%E6%9D%83/001_4733417.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/9.%E5%AE%A2%E6%88%B7%E4%BF%A1%E6%81%AF%E6%8E%88%E6%9D%83/002_4733417.png',
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/9.%E5%AE%A2%E6%88%B7%E4%BF%A1%E6%81%AF%E6%8E%88%E6%9D%83/003_4733417.png'
          ],
          requireTime: false,
          duration: 0
        }
      ],
      // 截图链接数组
      screenshotUrls: [],
      // 协议查看弹窗状态
      showAgreementViewer: false,
      currentAgreement: null,
      currentAgreementIndex: 0,
      isSequenceMode: false,
      // 当前正在查看的协议序列（用于序列模式）
      agreementSequence: [],
      // 当前正在查看的协议勾选类型（用于查看完毕后自动勾选）
      pendingAgreementType: null,
      // 存储录制数据
      currentRecordingData: null,
      // 批量上传投保人地址
      insuranceFileUrl: '',
      // 当前登录企业的实名信息（用于校验投保人表单是否与登录企业一致）
      loggedEnterprise: {
        enterpriseName: '',
        creditCode: ''
      },
    };
  },
  mounted() {
    // 从路由获取产品ID
    this.productId = this.$route.query.code;
    this.loadPlanList();
    // 查询企业信息（已登录才发请求，未登录由 axios 拦截器拦截）
    this.loadEnterpriseInfo();

    // 检查是否有保存的录制数据，如果有则恢复录制
    // console.log('planSelection mounted，检查录制状态...');
    // if (hasSavedEvents()) {
    //   console.log('检测到之前的录制数据，正在恢复...');
    //   startRecording();
    //   console.log('恢复录制后状态:', isRecordingActive());
    // } else if (!isRecordingActive()) {
    //   // 如果没有保存的数据且当前没有在录制，重新开始
    //   console.log('没有保存的录制数据且当前未在录制，开始新录制...');
    //   startRecording();
    //   console.log('启动新录制后状态:', isRecordingActive());
    // } else {
    //   console.log('录制已在进行中');
    // }

    // 恢复截图链接
    // const savedScreenshots = loadScreenshotUrls();
    // if (savedScreenshots.length > 0) {
    //   this.screenshotUrls = savedScreenshots;
    //   console.log('已恢复截图链接，数量:', savedScreenshots.length);
    // }

    // 读取 travelInsurance 页面传来的温馨提示弹窗截图
    // const promptScreenshot = sessionStorage.getItem('prompt_screenshot');
    // if (promptScreenshot) {
    //   const urls = JSON.parse(promptScreenshot);
    //   this.screenshotUrls.push(...urls);
    //   saveScreenshotUrls(this.screenshotUrls);
    //   sessionStorage.removeItem('prompt_screenshot');
    //   console.log('已合并温馨提示弹窗截图到截图列表，当前数量:', this.screenshotUrls.length);
    // }

    // 监听页面刷新/关闭，确保录制数据已保存
    // window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    // 移除事件监听
    // window.removeEventListener('beforeunload', this.handleBeforeUnload);
    // 组件销毁时（可能是页面刷新或跳转），录制数据已自动保存到 sessionStorage
    // 注意：sessionStorage 在同一标签页内共享，刷新/回退时可以恢复
    // console.log('planSelection 组件销毁，录制数据已保存到 sessionStorage');
  },
  computed: {
    currentCoverage() {
      return this.coverageData;
    },
    minDate() {
      const today = new Date();
      return today.toISOString().split('T')[0];
    },
    // 明天日期（起保日期从明天开始可选）
    tomorrowDate() {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toISOString().split('T')[0];
    },
    // 分页后的数据
    paginatedInsuredList() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.insuredList.slice(start, end);
    },
    // 总页数
    totalPages() {
      return Math.ceil(this.insuredList.length / this.pageSize);
    },
    // 是否包含非身份证类型
    hasNonIdCard() {
      return this.insuredList.some(item => item.certType && item.certType !== 1);
    },
    // 当前计划名称
    currentPlanName() {
      const plan = this.plans.find(p => p.id === this.selectedPlan);
      return plan ? plan.name : '计划一';
    },
    // 计算保费（单价 × 被保险人数量）
    calculatedPrice() {
      if (this.insuredList.length === 0) return '0.00';
      const priceArr = this.pricePerPersonPerDay[this.selectedPlan] || [];
      const found = this.dayRanges.find(r => this.selectedDays <= r.max);
      const rangeIndex = found ? found.index : 7;
      const pricePerPerson = priceArr[rangeIndex] || 0;
      const total = pricePerPerson * this.insuredList.length;
      return total.toFixed(2);
    },
    // 是否可以提交
    canSubmit() {
      return this.agreements.main && 
             this.agreements.personalInfo && 
             this.agreements.customerAuth &&
             this.insuredList.length > 0;
    },
    // 主协议列表（前7个）
    mainAgreements() {
      return this.agreementList.slice(0, 7);
    },
    // 个人信息共享协议
    personalInfoAgreement() {
      return this.agreementList.find(item => item.id === 'personalInfo') || {};
    },
    // 客户信息授权协议
    customerAuthAgreement() {
      return this.agreementList.find(item => item.id === 'customerAuth') || {};
    }
  },
  methods: {
    goBack() {
      // 有历史则返回上一页，否则回首页
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    },
    // 格式化时间为 yyyy-MM-dd HH:mm:ss
    formatDateTime(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 页面刷新/关闭前处理
    // handleBeforeUnload(event) {
    //   // 如果正在录制，强制保存一次数据到 sessionStorage
    //   if (isRecordingActive()) {
    //     // 保存当前录制数据
    //     const events = getRecordingEvents();
    //     if (events.length > 0) {
    //       try {
    //         sessionStorage.setItem('rrweb_recording_events', JSON.stringify(events));
    //         console.log('页面关闭前录制数据已保存，事件数:', events.length);
    //       } catch (e) {
    //         console.error('保存录制数据失败:', e);
    //       }
    //     }
    //   }
    // },

    // 验证联系方式格式（手机号、固话、400电话等）
    validatePhone() {
      const phone = this.policyholder.phone;
      if (!phone) {
        this.phoneError = '请输入联系方式';
        return false;
      }
      // 去掉空格、横杠、括号等，只保留数字和+号
      const cleanPhone = phone.replace(/[\s\-\(\)]/g, '');
      
      // 手机号：1开头的11位数字
      if (/^1[3-9]\d{9}$/.test(cleanPhone)) {
        this.phoneError = '';
        return true;
      }
      
      // 400/800电话：400/800开头的10位数字
      if (/^(400|800)\d{7}$/.test(cleanPhone)) {
        this.phoneError = '';
        return true;
      }
      
      // 固话：+86开头或纯数字，区号3-4位+号码7-8位
      const landlinePhone = cleanPhone.replace(/^\+86/, '');
      if (/^\d{3,4}\d{7,8}$/.test(landlinePhone)) {
        this.phoneError = '';
        return true;
      }
      
      // 国际电话：以+开头
      if (/^\+\d{6,15}$/.test(cleanPhone)) {
        this.phoneError = '';
        return true;
      }
      
      this.phoneError = '请输入正确的联系方式';
      return false;
    },
    
    // 验证统一信用代码格式（轻度校验）
    validateCertNo() {
      const certNo = this.policyholder.certNo;
      if (!certNo) {
        this.certNoError = '请输入统一信用代码';
        return false;
      }
      // 统一社会信用代码为18位
      if (certNo.length !== 18) {
        this.certNoError = '统一信用代码为18位';
        return false;
      }
      // 轻度校验：18位数字和大写字母组成
      const certNoReg = /^[0-9A-Z]{18}$/;
      if (!certNoReg.test(certNo)) {
        this.certNoError = '请输入正确的统一信用代码';
        return false;
      }
      this.certNoError = '';
      return true;
    },
     // 验证邮箱格式
    validateEmail() {
      const email = this.policyholder.email;
      if (!email) {
        this.emailError = '请输入邮箱';
        return false;
      }
      const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailReg.test(email)) {
        this.emailError = '请输入正确的邮箱地址';
        return false;
      }
      this.emailError = '';
      return true;
    },
    
    // 获取证件类型文字
    getCertTypeText(certType) {
      const map = {
        1: '身份证', 2: '护照', 3: '军人证', 4: '港澳通行证',
        5: '驾驶证', 6: '港澳居民来往内地通行证', 7: '临时身份证',
        8: '外国人永久居留身份证', 9: '港澳台居民居住证'
      };
      return map[certType] || certType || '-';
    },
    // 获取性别文字
    getGenderText(gender) {
      const map = { 0: '男', 1: '女' };
      return map[gender] || gender || '-';
    },
    // 获取关系文字
    getRelationTypeText(relationType) {
      const map = {
        1: '本人', 2: '配偶', 3: '父子', 4: '父女', 5: '受益人',
        6: '被保人', 7: '投保人', 8: '转换不详', 9: '其他', 10: '母子',
        11: '母女', 12: '兄弟', 13: '姊妹', 14: '兄妹', 15: '姐弟',
        16: '祖孙', 17: '雇佣', 18: '子女', 19: '父母'
      };
      return map[relationType] || relationType || '-';
    },
    // 加载计划列表
    async loadPlanList() {
      try {
        const res = await getPlanList(this.productId);
        // 根据实际返回结构处理
        if (res && res.code == 0) {
          this.plans = res.data;
          // 如果有计划，默认选中第一个
          if (this.plans.length > 0) {
            this.selectedPlan = this.plans[0].id;
            this.loadCoverageList(this.plans[0].id)
          }
        }
      } catch (error) {
        console.error('加载计划列表失败', error);
      }
    },
    // 加载企业信息（需登录，未登录会被 axios 拦截器拒绝并弹出登录框）
    async loadEnterpriseInfo() {
      // 仅在已登录时请求；未登录直接 return，拦截器会兜底
      if (localStorage.getItem("app_login") !== "1") return;
      // 从登录态中取 userId
      let userId = "";
      try {
        const raw = localStorage.getItem("userInfo");
        if (raw) {
          const info = JSON.parse(raw);
          userId = info.id || "";
        }
      } catch (e) {
        console.error("解析登录用户信息失败", e);
      }
      if (!userId) return;
      try {
        const res = await getEnterpriseInfo(userId);
        // 根据实际返回结构填充投保人表单（接口为 {code, data, head, msg}）
        if (res && res.code === 0 && res.data) {
          const d = res.data;
          this.policyholder.name = d.enterpriseName || '';
          this.policyholder.certNo = d.creditCode || '';
          this.policyholder.phone = d.phone || '';
          this.policyholder.email = d.email || '';
          // 记录登录企业的实名信息（用于校验投保人表单）
          this.loggedEnterprise.enterpriseName = d.enterpriseName || '';
          this.loggedEnterprise.creditCode = d.creditCode || '';
        }
      } catch (error) {
        console.error("加载企业信息失败", error);
      }
    },
    selectPlan(planId) {
      this.selectedPlan = planId;
      this.loadCoverageList(planId);
    },
    async loadCoverageList(planId) {
      const plan = this.plans.find(p => p.id === planId);
      if (!plan) return;
      try {
        const res = await getCoverageList(plan.id);
        if (res && res.code == 0) {
          this.coverageData = res.data || [];
        }
      } catch (error) {
        console.error('加载保障列表失败', error);
      }
    },
    selectDays(days) {
      this.selectedDays = days;
      // 自动计算结束日期
      this.calculateEndDate();
    },
    // 计算结束日期
    calculateEndDate() {
      if (this.startDate && this.selectedDays) {
        const start = new Date(this.startDate);
        const end = new Date(start);
        end.setDate(start.getDate() + this.selectedDays - 1);
        this.endDate = end.toISOString().split('T')[0];
        this.calculateDays();
      }
    },
    calculateDays() {
      if (this.startDate && this.endDate) {
        const start = new Date(this.startDate);
        const end = new Date(this.endDate);
        const diffTime = end - start;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
        this.calculatedDays = diffDays > 0 ? diffDays : 0;
      } else {
        this.calculatedDays = this.selectedDays || 0;
      }
    },
    handleAddInsured(insuredData) {
      this.insuredList.push(insuredData);
      // 添加后跳转到最后一页
      this.$nextTick(() => {
        this.currentPage = this.totalPages;
      });
    },
    handleBatchImport(insuredList, fileUrl) {
      // 批量导入被保险人
      this.insuredList.push(...insuredList);
      // 记录批量上传投保人的文件地址
      this.insuranceFileUrl = fileUrl ? fileUrl : '';
      this.$nextTick(() => {
        this.currentPage = this.totalPages;
      });
    },
    submitOrder() {
      // 验证保障期限
      if (!this.selectedDays) {
        this.$message.error('请选择保障期限');
        return;
      }
      if (!this.startDate) {
        this.$message.error('请选择生效日期');
        return;
      }
      // 验证投保人信息
      if (!this.policyholder.name) {
        this.$message.error('请输入投保人姓名');
        return;
      }
      if (!this.policyholder.certNo) {
        this.$message.error('请输入投保人证件号码');
        return;
      }
      // 验证统一信用代码
      if (!this.validateCertNo()) {
        this.$message.error('统一信用代码格式错误');
        return;
      }
      // 验证当前登录企业与输入的投保人信息是否一致（仅在已加载到登录企业信息时校验）
      if (this.loggedEnterprise.enterpriseName || this.loggedEnterprise.creditCode) {
        const inputName = (this.policyholder.name || '').trim();
        const inputCode = (this.policyholder.certNo || '').trim();
        const loginName = (this.loggedEnterprise.enterpriseName || '').trim();
        const loginCode = (this.loggedEnterprise.creditCode || '').trim();
        if (inputName !== loginName || inputCode !== loginCode) {
          this.$message.error('当前登录企业信息与输入信息不一致，请先退出登录');
          return;
        }
      }
      // 验证手机号
      if (!this.validatePhone()) {
        this.$message.error('联系方式格式错误');
        return;
      }
      // 验证邮箱
      if (!this.validateEmail()) {
        this.$message.error('邮箱格式错误');
        return;
      }
      // 验证协议勾选
      if (!this.agreements.main) {
        this.$message.error('请先阅读并同意主协议');
        return;
      }
      if (!this.agreements.personalInfo) {
        this.$message.error('请先阅读并同意个人信息共享协议');
        return;
      }
      if (!this.agreements.customerAuth) {
        this.$message.error('请先阅读并同意客户信息授权协议');
        return;
      }
      // 验证被保险人
      if (this.insuredList.length === 0) {
        this.$message.error('请添加被保险人');
        return;
      }
      // 可以提交订单
      this.doSubmitOrder();
    },
    
    // 处理协议勾选（勾选时打开协议弹窗）
    handleAgreementCheck(type, checked) {
      if (checked) {
        // 勾选时，先打开协议弹窗查看
        const agreementMap = {
          main: this.agreementList.slice(0, 7),  // 前7个主协议
          personalInfo: [this.personalInfoAgreement],
          customerAuth: [this.customerAuthAgreement]
        };
        const agreements = agreementMap[type];
        if (agreements && agreements.length > 0) {
          this.pendingAgreementType = type;
          // 暂时取消勾选（阻止用户直接勾选）
          this.agreements[type] = false;
          // 打开协议弹窗（序列模式，依次查看所有协议）
          this.isSequenceMode = true;
          this.agreementSequence = agreements;
          this.currentAgreementIndex = 0;
          this.currentAgreement = agreements[0];
          this.showAgreementViewer = true;
        }
      } else {
        // 取消勾选
        this.agreements[type] = false;
      }
    },
    
    // 协议查看完成回调
    handleAgreementViewed() {
      // 查看完毕后自动勾选
      if (this.pendingAgreementType) {
        this.agreements[this.pendingAgreementType] = true;
        this.pendingAgreementType = null;
      }
    },
    
    // 打开单个协议（点击标题查看，无时长限制）
    openAgreement(agreement) {
      if (!agreement || !agreement.id) return;
      this.isSequenceMode = false;
      this.currentAgreement = agreement;
      this.showAgreementViewer = true;
    },
    
    // 开始协议序列查看流程（点击立即投保）
    startAgreementSequence() {
      this.isSequenceMode = true;
      this.currentAgreementIndex = 0;
      this.currentAgreement = this.agreementList[0];
      this.showAgreementViewer = true;
    },
    
    // 协议弹窗关闭
    handleAgreementClose() {
      this.showAgreementViewer = false;
      this.currentAgreement = null;
      this.currentAgreementIndex = 0;
      this.agreementSequence = [];
      this.isSequenceMode = false;
    },
    
    // 协议序列 - 下一个
    async handleAgreementNext() {
      // 先截图当前协议页
      // await this.captureAgreementPage();
      
      this.currentAgreementIndex++;
      if (this.currentAgreementIndex < this.agreementSequence.length) {
        this.currentAgreement = this.agreementSequence[this.currentAgreementIndex];
      }
    },
    
    // 协议序列 - 完成所有
    async handleAgreementComplete() {
      // 先截图最后一个协议页
      // await this.captureAgreementPage();
      
      this.showAgreementViewer = false;
      this.currentAgreement = null;
      this.currentAgreementIndex = 0;
      this.agreementSequence = [];
      this.isSequenceMode = false;
      // 保存录制数据
      // if (recordingData) {
      //   this.currentRecordingData = recordingData;
      // }
      // 所有协议查看完成，自动勾选checkbox
      if (this.pendingAgreementType) {
        this.agreements[this.pendingAgreementType] = true;
        this.pendingAgreementType = null;
      }
    },
    
    // ==================== 截图相关方法 ====================
    
    /**
     * 截图并上传
     * @param {HTMLElement} element - 截图目标元素
     * @param {string} pageName - 页面标识
     * @returns {Promise<string|null>} 返回上传后的图片URL
     */
    // async captureAndUpload(element, pageName) {
    //   try {
    //     const { blob } = await captureAsBlob(element);
    //     const fileName = `screenshot_${pageName}_${Date.now()}.jpg`;
    //     const res = await uploadScreenshot(blob, fileName);
    //     
    //     if (res && res.code == 0 && res.data) {
    //       this.screenshotUrls.push(res.data);
    //       // 保存截图链接到 sessionStorage
    //       saveScreenshotUrls(this.screenshotUrls);
    //       console.log('截图上传成功:', pageName, res.data);
    //       return res.data;
    //     }
    //     console.warn('截图上传返回异常:', res);
    //     return null;
    //   } catch (error) {
    //     console.error('截图上传失败:', error);
    //     return null;
    //   }
    // },
    
    /**
     * 截图温馨提示弹窗
     * @returns {Promise<string|null>}
     */
    // async capturePromptDialog() {
    //   // 找到温馨提示弹窗元素
    //   const dialog = document.querySelector('.v-dialog--active .prompt-dialog') ||
    //                   document.querySelector('.prompt-dialog-content') ||
    //                   document.querySelector('.v-dialog--active');
    //   if (dialog) {
    //     return await this.captureAndUpload(dialog, 'prompt_dialog');
    //   }
    //   console.warn('未找到温馨提示弹窗元素');
    //   return null;
    // },
    
    /**
     * 截图协议弹窗
     * @returns {Promise<string|null>}
     */
    // async captureAgreementPage() {
    //   // 找到协议弹窗元素（增加子条款列表选择器）
    //   const modal = document.querySelector('.agreement-viewer-modal .children-list-wrapper') ||
    //                  document.querySelector('.agreement-viewer-modal .image-wrapper') ||
    //                  document.querySelector('.agreement-viewer-modal .agreement-content') ||
    //                  document.querySelector('.agreement-content') ||
    //                  document.querySelector('.children-list-wrapper') ||
    //                  document.querySelector('.v-dialog--active .agreement-viewer');
    //   if (modal) {
    //     const agreementId = this.currentAgreement ? this.currentAgreement.id : 'unknown';
    //     const pageName = `agreement_${agreementId}_${this.currentAgreementIndex}`;
    //     return await this.captureAndUpload(modal, pageName);
    //   }
    //   console.warn('未找到协议弹窗元素');
    //   return null;
    // },
    
    /**
     * 截图子条款弹窗（子条款列表中的某个子条款内容）
     * @param {Object} child - 子条款对象
     * @returns {Promise<string|null>}
     */
    // async captureChildAgreement(child) {
    //   // 查找子条款查看模式的弹窗内容
    //   const childWrapper = document.querySelector('.agreement-viewer-modal .child-image-wrapper') ||
    //                        document.querySelector('.agreement-viewer-modal .image-wrapper') ||
    //                        document.querySelector('.child-image-wrapper') ||
    //                        document.querySelector('.image-wrapper');
    //   if (childWrapper) {
    //     const childId = child ? child.id : 'unknown';
    //     const parentId = this.currentAgreement ? this.currentAgreement.id : 'unknown';
    //     const pageName = `child_agreement_${parentId}_${childId}`;
    //     return await this.captureAndUpload(childWrapper, pageName);
    //   }
    //   console.warn('未找到子条款弹窗元素');
    //   return null;
    // },
    
    // ==================== 子条款事件处理 ====================
    
    /**
     * 子条款打开时触发（用于截图）
     * @param {Object} child - 子条款对象
     */
    // async handleChildAgreementOpened(child) {
    //   console.log('子条款已打开:', child ? child.title : 'unknown');
    //   // 等待内容渲染后截图
    //   this.$nextTick(async () => {
    //     await this.captureChildAgreement(child);
    //   });
    // },
    
    /**
     * 截图整个订单页面
     * @returns {Promise<string|null>}
     */
    // async captureOrderPreview() {
    //   const pageElement = document.querySelector('.plan-selection-page') ||
    //                       document.querySelector('.main-container');
    //   if (pageElement) {
    //     return await this.captureAndUpload(pageElement, 'order_preview');
    //   }
    //   console.warn('未找到订单页面元素');
    //   return null;
    // },
    
    // 实际提交订单
    async doSubmitOrder() {
      // 防止重复提交
      if (this.submitting) {
        return;
      }
      this.submitting = true;

      // 校验被保险人是否有重复证件号
      const certNoList = this.insuredList.map(item => item.certNo).filter(v => v);
      const duplicateList = certNoList.filter((certNo, index) => certNoList.indexOf(certNo) !== index);
      if (duplicateList.length > 0) {
        this.$message.error(`被保险人证件号重复: ${[...new Set(duplicateList)].join('、')}`);
        this.submitting = false;
        return;
      }

      const submitData = {
        policySubmitDto: {
          planId: this.selectedPlan,
          productId: this.productId,
          insureDays: this.calculatedDays,
          effectiveDate: this.startDate,
          expiryDate: this.endDate,
          totalPrice: this.calculatedPrice
        },
        policyholderDto: this.policyholder,
        insuredDtoList: this.insuredList.map(item => ({
          name: item.name,
          certType: item.certType,
          certNo: item.certNo,
          phone: item.phone,
          birthday: item.birthday || null,
          gender: item.gender !== '' && item.gender !== null ? item.gender : null,
          relationType: item.relationType,
        }))
      };

      try {
        // 跳转第三方支付前，先截图订单预览页面
        // await this.captureOrderPreview();

        // 跳转第三方支付前，先停止录制并获取数据
        // let recordingEvents = [];
        // const recordingEndTime = new Date(); // 记录结束时间
        // const isActive = isRecordingActive();
        // console.log('当前录制状态:', isActive);
        // 
        // // 先获取录制开始时间（stopRecording 会清除 sessionStorage）
        // const recordingStartTime = isActive ? sessionStorage.getItem('recording_start_time') : null;
        // console.log('录制开始时间:', recordingStartTime);
        // 
        // if (isActive) {
        //   recordingEvents = stopRecording();
        //   console.log('跳转支付前录制数据已保存，事件数:', recordingEvents.length);
        // } else {
        //   console.log('录制未启动，跳过停止录制');
        // }

        const res = await submitOrder(submitData);
        if (res && res.code == 0) {
          // 保存订单数据到 sessionStorage（支付返回后可能需要）
          sessionStorage.setItem('last_order_data', JSON.stringify(res.data));
          console.log('订单数据已保存到 sessionStorage:', res.data);
          
          // 订单提交成功，提交录屏数据到监控服务器
          // try {
          //   const { orderCode, paymentUrl, startTime, endTime, ...params} = res.data;
          //   let monitorCode = '';
          //   // 获取唯一编码
          //   if (orderCode) {
          //     const monitorRes = await getMonitorCode(orderCode);
          //     if (monitorRes && monitorRes.code == 0) {
          //       monitorCode = monitorRes.data;
          //       console.log('获取到监控唯一编码:', monitorCode);
          //       console.log('录制数据事件数:', recordingEvents.length);
          //       
          //       // 保存监控详情（录屏数据）
          //       const monitorData = {
          //         monitorCode,
          //         orderCode,
          //         monitorContent: JSON.stringify(recordingEvents),
          //         monitorType: 1,
          //         insuranceFileUrl: this.insuranceFileUrl,
          //         startTime: recordingStartTime ? this.formatDateTime(recordingStartTime) : '', // 录制开始时间
          //         endTime: this.formatDateTime(recordingEndTime), // 录制结束时间
          //         ...params
          //       };
          //       console.log('发送的监控数据大小:', new Blob([monitorData.monitorContent]).size, 'bytes');
          //       console.log('发送的监控数据:', monitorData);
          //       
          //       const saveRes = await saveMonitorDetail(monitorData);
          //       console.log('监控数据保存返回:', saveRes);
          //       console.log('监控数据保存成功');
          //       
          //       // 保存截图链接列表
          //       if (this.screenshotUrls.length > 0) {
          //         await saveScreenshotLinks({
          //           monitorCode,
          //           screenshots: [{
          //             type: 1,
          //             urls: this.screenshotUrls
          //           }]
          //         });
          //         console.log('截图链接保存成功');
          //       }
          //     }
          //   }
          // } catch (err) {
          //   console.error('监控数据提交失败:', err);
          // }

          // 清空本地录制数据（成功后）
          // clearSavedEvents();
          // clearScreenshotUrls();
          // this.screenshotUrls = [];
          // console.log('录制备份数据和截图链接已清空');

          // 如果有第三方跳转链接则跳转，否则提示成功
          const { paymentUrl, redirectFlag} = res.data || {};
          if (redirectFlag == 1 && paymentUrl) {
            // 跳转第三方支付页面
            window.location.href = paymentUrl;
          } else if (redirectFlag == 2) {
            this.$message.success('订单提交成功！');
            this.$router.push({ name: 'pay-success'});
          } else {
            this.$message.success('订单提交失败！');
          }
        } else {
          this.$message.error(res.msg || '订单提交失败');
        }
        this.submitting = false;
      } catch (error) {
        console.error('订单提交失败', error);
        this.submitting = false;
        // 注意：接口失败时不清空录制数据，用户重新提交时可能还需要
        // 接口失败时保持 loading 状态，用户需要重新点击
      }
    },
    removeInsured(index) {
      const realIndex = (this.currentPage - 1) * this.pageSize + index;
      this.insuredList.splice(realIndex, 1);
      // 如果删除后当前页没有数据了，回到上一页
      if (this.paginatedInsuredList.length === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.plan-selection-page {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 20px 0;
}

// 返回按钮（与保单查询页风格一致）
.back-btn {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 7px 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  color: #666;
  font-size: 14px;
  transition: all 0.2s;

  .back-icon {
    font-size: 16px;
    line-height: 1;
    font-weight: 600;
  }

  &:hover {
    color: #dd122a;
    border-color: #dd122a;
  }

  &:active {
    transform: scale(0.98);
  }
}

// 返回工具栏（与左侧内容区左对齐，靠近顶部）
.page-toolbar {
  max-width: 1200px;
  margin: 0 auto 12px;
  padding: 0 20px;
}

// 步骤条样式
.step-header {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto 30px;
  padding: 0 20px;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .step-number {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: #E6E7EB;
    color: #6B7280;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 8px;
  }
  
  .step-text {
    font-weight: 500;
    font-size: 14px;
    color: #999;
  }
  
  &.active {
    .step-number {
      background-color: #dd122a;
      color: #fff;
    }
    
    .step-text {
      color: #dd122a;
    }
  }
}

.step-line {
  width: 100px;
  height: 2px;
  background-color: #e0e0e0;
  margin: 0 20px;
  margin-bottom: 25px;
}

// 主内容区
.main-container {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  gap: 20px;
}

// 左侧内容
.left-content {
  width: 860px;
  flex-shrink: 0;
  background-color: #fff;
  border-radius: 8px;
  padding: 30px;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 20px;
  
  .title-icon {
    width: 4px;
    height: 16px;
    background-color: #dd122a;
    margin-right: 8px;
    border-radius: 2px;
  }
}

// 右侧价格栏
.right-sidebar {
  width: 320px;
  flex-shrink: 0;
}

// 计划卡片样式
.plan-cards-area {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}

.plan-card {
  flex: 1;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 13px 19px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #fff;
  
  &:hover {
    border-color: #dd122a;
  }
  
  &.active {
    border-color: #dd122a;
    
    .plan-name {
      color: #dd122a;
    }
  }
  
  .plan-name {
    font-size: 18px;
    font-weight: 500;
    color: #262626;
    margin-bottom: 3px;
  }
  
  .plan-type {
    font-size: 14px;
    color: #666;
  }
}

// 保障项目表格样式
.coverage-table-area {
  margin-bottom: 28px;
  
  .coverage-table {
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #F1F6F9;
    padding: 14px 24px;
    font-size: 14px;
    font-weight: 500;
    color: #1D1D1D;
  }
  
  .table-body {
    background-color: #F8FAFC;
  }
  
  .table-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 24px;
    border-bottom: 1px solid #EFEFEF;
    font-size: 14px;
    
    &:last-child {
      border-bottom: none;
    }
    
    .row-name {
      color: #1D1D1D;
    }
    
    .row-amount {
      color: #1D1D1D;
      font-weight: 500;
    }
  }
}

// 特别约定样式
.special-notes-area {
  margin-bottom: 30px;
  
  .notes-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 12px;
  }
  
  .notes-content {
    background-color: #FEF6F7;
    padding: 20px 24px;
    border-radius: 8px;
    
    p {
        margin-bottom: 0;
        font-size: 12px;
        color: #999;
        .notes-content-weight {
          font-weight: 600;
        }
    }
  }
}

// 保障期限样式
.duration-section {
  margin-bottom: 30px;
  
  .day-options {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  
  .day-option {
    width: 88px;
    height: 38px;
    border: 1px solid #F9FAFB;
    border-radius: 4px;
    background-color: #F9FAFB;
    font-size: 14px;
    color: #666;
    font-weight: 500;
    text-align: center;
    line-height: 38px;
    cursor: pointer;
    transition: all 0.3s;
    
    &:hover {
      border-color: #dd122a;
      color: #dd122a;
    }
    
    &.active {
      color: #dd122a;
      background-color: #FEF6F7;
    }
  }
  
  .date-picker-row {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }
  
  .date-field {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .date-label {
      font-size: 14px;
      color: #666;
      white-space: nowrap;
      
      .required {
        color: #ff4d4f;
        margin-left: 2px;
      }
    }
    
    .v-text-field {
      width: 160px;
    }
    
    .disabled-field {
      .v-input__slot {
        background-color: #f5f5f5 !important;
      }
      
      input {
        color: #999 !important;
      }
    }
  }
  
  .days-calculation {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
    
    .calc-label {
      font-size: 14px;
      color: #dd122a;
    }
    
    .calc-value {
      font-size: 14px;
      color: #dd122a;
      font-weight: 500;
    }
  }
}

// 投保人信息样式
.policyholder-section {
  margin-bottom: 30px;
  
  .form-row {
    display: flex;
    gap: 20px;
    margin-bottom: 16px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .form-field {
    flex: 1;
    
    .field-label {
      display: block;
      font-size: 14px;
      color: #666;
      margin-bottom: 8px;
      
      .required {
        color: #ff4d4f;
        margin-left: 2px;
      }
    }
    
    .custom-field {
      .v-input__control {
        min-height: 40px;
      }
      
      .v-input__slot {
        min-height: 40px;
      }
    }
  }
}

// 被保险人信息样式
.insured-section {
  margin-bottom: 30px;
  
  .insured-actions {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
    
    .action-btn {
      text-transform: none;
      font-size: 14px;
      height: 36px;
      border-radius: 4px;
      color: #fff;
      .v-icon {
        margin-right: 4px;
      }
    }
  }
  
  .insured-table-wrapper {
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 16px;
    overflow-x: auto;

    .empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 60px 20px;
      color: #999;

      .empty-text {
        margin-top: 12px;
        font-size: 14px;
      }
    }
  }
  
  .insured-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    
    thead {
      background-color: #F5F5F5;
      
      th {
        padding: 12px 8px;
        text-align: center;
        font-weight: 500;
        color: #333;
        border-bottom: 1px solid #e8e8e8;
        white-space: nowrap;
      }
    }
    
    tbody {
      tr {
        border-bottom: 1px solid #e8e8e8;
        
        &:last-child {
          border-bottom: none;
        }
        
        td {
          padding: 12px 8px;
          text-align: center;
          vertical-align: middle;
          color: #333;
          
          .delete-text {
            color: #dd122a;
            cursor: pointer;
            font-size: 14px;
            
            &:hover {
              text-decoration: underline;
            }
          }
        }
        
        td:first-child {
          color: #999;
        }
      }
    }
  }
  
  .beneficiary-notice {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    
    span {
      font-size: 14px;
      color: #dd122a;
    }
  }
  
  .pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    
    .v-pagination {
      .v-pagination__item--active {
        background-color: #dd122a !important;
        border-color: #dd122a !important;
      }
      
      .v-pagination__item {
        color: #666;
      }
    }
  }
}

// 右侧价格栏样式
.right-sidebar {
  width: 300px;
  flex-shrink: 0;
  
  .price-card {
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    
    &.sticky-card {
      position: sticky;
      top: 120px;
    }
    
    .price-header {
      background-color: #DD122A;
      padding: 24px;
      text-align: center;
      color: #fff;
      
      .price-title {
        font-size: 16px;
        margin-bottom: 8px;
      }
      
      .price-amount {
        .currency {
          font-size: 16px;
          margin-right: 2px;
        }  
        .amount {
          font-size: 42px;
          font-weight: 600;
          line-height: 1;
        }
      }
    }
    
    .plan-info {
      padding: 20px 18px;
      border-bottom: 1px dashed #e8e8e8;
      
      .info-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        .info-label {
          font-size: 14px;
          color: #666;
        }
        
        .info-value {
          font-size: 14px;
          color: #666;
        }
      }
    }
    
    .agreement-section {
      padding: 16px 18px;
    
      .agreement-item {
        margin-bottom: 8px;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        .agreement-checkbox {
          margin-top: 0;
          padding-top: 0;
          
          .v-input--selection-controls__input {
            margin-right: 8px;
          }
          
          .v-label {
            font-size: 12px;
            line-height: 1.5;
          }
        }
        
        .agreement-text {
          font-size: 13px;
          color: #666;
          line-height: 1.6;
        }
        
        .agreement-link {
          color: #dd122a;
          text-decoration: none;
          
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    
    // 投保人声明
    .declaration-section {
      padding: 0 18px;
      margin-bottom: 12px;
      
      .declaration-title {
        font-size: 13px;
        color: #333;
        font-weight: 500;
        margin-bottom: 8px;
      }
      
      .declaration-content {
        font-size: 12px;
        color: #666;
        p {
          margin-bottom: 6px;
          text-align: justify;
        }
      }
    }
    
    .submit-btn {
      margin: 16px 18px 24px;
      height: 44px;
      border-radius: 22px;
      font-size: 16px;
      font-weight: 500;
      text-transform: none;
      letter-spacing: 0;
      width: calc(100% - 36px);
      min-width: auto;
      color: #fff;
      
      &.v-btn--disabled {
        background-color: #ccc !important;
        color: #fff !important;
      }
    }
  }
}
</style>
